import MediaQuery from 'react-responsive';
import Svg, { Props as SVGProps } from 'react-inlinesvg';
import Wave2Mobile from '../components/waves/wave2mobile';
import Wave4 from '../components/waves/wave4';
import Wave5 from '../components/waves/wave5';
import Key8 from '../components/keys/key8';
import Key7Mobile from '../components/keys/key7mobile';
import Wave3Mobile from '../components/waves/wave3mobile';

function Commitment({ animate }) {
   return (
      <>
         <div className="commitment bg-sand wave wave--top">
            <MediaQuery minWidth={768}>
               <Wave4 />
            </MediaQuery>
            <MediaQuery maxWidth={767}>
               <Wave2Mobile />
            </MediaQuery>
            <div className="flex block1">
               <div className="col-1/2">
                  <h2>Our commitment to you</h2>
                  <p>
                     You’ve trusted us with one of life’s biggest decisions, and
                     you have made the right choice. We want you to be over the
                     moon with your new home and the service you receive along
                     the way. Keeping you informed and making sure the whole
                     process is clear and straightforward is an essential part
                     of The Miller Difference, it’s what we do.
                  </p>
               </div>
            </div>
            <div className="flex block2">
               <div className="col-1/2 ">
                  <img
                     srcset="/ReactAssets/CustomerJourney/Welcome2x1.jpeg 1x, /ReactAssets/CustomerJourney/Welcome2x2.jpeg 2x"
                     src="/ReactAssets/CustomerJourney/Welcome2x1.jpeg"
                     alt="Welcome"
                  />
               </div>
               <div className="col-1/2 ">
                  <div class="content">
                     <h3>Your Reservation and Welcome Meeting</h3>
                     <p>
                        Now’s the time when your Development Sales Manager will
                        introduce you to your Site Manager, either in person at
                        the sales centre, by telephone or video call. They’ll
                        both take you through all the details of buying and
                        building your new home, help you explore the options and
                        extras available and happily answer any questions. It’s
                        time to experience all the exciting possibilities for
                        your amazing new home.
                     </p>
                  </div>
               </div>
            </div>
            <div className="flex block3">
               <div className="col-1/3 ">
                  <img
                     src={`/ReactAssets/CustomerJourney/svg/small-icon-1.svg`}
                     width="140"
                     className="small-icon"
                  />
                  <div class="content">
                     <h3>Our Customer Charter</h3>
                     <p>
                        Our{' '}
                        <a
                           href="/help-and-advice/our-customer-charter.aspx"
                        >
                           Customer Charter
                        </a>{' '}
                        is a simple and clear guide that helps you understand
                        everything we will do for you during your home buying
                        process. We also abide by the{' '}
                        <a href="https://consumercode.co.uk/" target="_blank">
                           Consumer Code for Home Builders
                        </a>{' '}
                        which ensures you get the very best service from us at
                        every stage.
                     </p>
                  </div>
               </div>
               <div className="col-1/3">
                  <img
                     src={`/ReactAssets/CustomerJourney/svg/small-icon-2.svg`}
                     width="140"
                     className="small-icon"
                  />
                  <div class="content">
                     <h3>My Miller Home</h3>
                     <p>
                        We know you’ll be eager to know what’s going on, all the
                        time. That’s why the app and website is packed with info
                        on the buying and build process and, when you reserve,
                        you will receive regular updates from us too including:
                     </p>
                     <ul>
                        <li>
                           Every buying and building update (big and small)
                        </li>
                        <li>All your documents and videos</li>
                        <li>See a record of every meeting we’ve had</li>
                        <li>
                           Take a look at all your wonderful options and extras
                        </li>
                     </ul>
                  </div>
               </div>
               <div className="col-1/3">
                  <MediaQuery minWidth={768}>
                     <Key8 animate={animate} />
                  </MediaQuery>
                  <MediaQuery maxWidth={767}>
                     <Key7Mobile animate={animate} />
                  </MediaQuery>
               </div>
            </div>
            <MediaQuery minWidth={768}>
               <Wave5 />
            </MediaQuery>
            <MediaQuery maxWidth={767}>
               <Wave3Mobile />
            </MediaQuery>
         </div>
      </>
   );
}

export default Commitment;
